import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { baseUrl } from '../../../enum/constant';
import DataTable from 'react-data-table-component';

const UserList = ({ onViewUser }) => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [editUser, setEditUser] = useState(null);
  const [updatedUserData, setUpdatedUserData] = useState({ email: '' });
  const [successMessage, setSuccessMessage] = useState('');
  const [searchText, setSearchText] = useState(''); // Added state for search text
  const usersPerPage = 10;

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const base = baseUrl;
      const response = await axios.get(base + 'api/admin/userlist', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
      setUsers(response.data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateUser = async (id) => {
    if (!updatedUserData.email.trim()) {
      setError('Email field cannot be empty.');
      return;
    }

    try {
      const base = baseUrl;
      const response = await axios.put(
        `${base}api/admin/userlist/${id}`,
        updatedUserData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        }
      );
      setUsers(users.map((user) => (user.id === id ? response.data : user)));
      setEditUser(null);
      setUpdatedUserData({ email: '' });
      setSuccessMessage('User updated successfully.');
      setTimeout(() => setSuccessMessage(''), 3000);
    } catch (err) {
      setError(err.message);
    }
  };

  const handleDeleteUser = async (id) => {
    const isConfirmed = window.confirm('Are you sure you want to delete this user?');
    if (!isConfirmed) return;

    try {
      const base = baseUrl;
      await axios.delete(`${base}api/admin/userlist/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
      setUsers(users.filter((user) => user.id !== id));
      setSuccessMessage('User deleted successfully.');
      setTimeout(() => setSuccessMessage(''), 3000);
    } catch (err) {
      setError(err.message);
    }
  };

  const startEditing = (user) => {
    setEditUser(user);
    setUpdatedUserData({ email: user.email });
  };

  // Handle View User by ID
  const handleViewUser = (userId) => {
    onViewUser(userId);
  };

  // Filter users based on the search text
  const filteredUsers = users.filter((user) =>
    user.email.toLowerCase().includes(searchText.toLowerCase()) ||
    user.id.toString().includes(searchText)
  );

  if (loading) return <div className="mt-md-5 pt-md-5"><div className="mt-md-5"><div className="alert alert-info">Loading...</div></div></div>;
  if (error) return <div className="mt-md-5 pt-md-5"><div className="mt-md-5"><div className="alert alert-danger">Error: {error}</div></div></div>;

  return (
    <div className="cus-dash-container container my-0 user-sec">
      {successMessage && (
        // <div className="alert alert-success alert-dismissible fade show" role="alert">
        //   {successMessage}
        //   <button
        //     type="button"
        //     className="btn-close"
        //     aria-label="Close"
        //     onClick={() => setSuccessMessage('')}
        //   ></button>
        // </div>
        <div class="cus-alert-msg alert-success" role="alert">
          <div class="icon">
            ✔
            {/* <i class="bi bi-check-lg"></i> */}
          </div>
          <p class="message mb-0">{successMessage}</p>
        </div>
      )}
      <h5 className="mb-2">User List</h5>

      <input
        type="text"
        placeholder="Search by email or ID"
        className="form-control mb-3"
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)} // Update searchText on input change
      />

      {/* DataTable */}
      <DataTable
        columns={[
          { name: 'ID', selector: (row) => row.id },
          { name: 'Email', selector: (row) => row.email },
          {
            name: 'Date',
            selector: (row) => new Date(row.created_at).toISOString().split('T')[0]
          },
          {
            name: 'Actions',
            button: true,
            cell: (row) => (
              <div className="d-flex">
                <button className="badge bg-primary m-1 p-2 text-light" style={{ border: 'none' }} onClick={() => onViewUser(row.id)}>
                  Bank detail
                </button>
                <button className="badge bg-warning m-1 p-2 text-light" style={{ border: 'none' }} onClick={() => startEditing(row)}>
                  Edit
                </button>

                <button className="badge bg-danger m-1 p-2 text-light" style={{ border: 'none' }} onClick={() => handleDeleteUser(row.id)}>
                  Delete
                </button>
              </div>
            ),
            style: { marginRight: '40px' }
          },
        ]}
        data={filteredUsers} // Use filtered data for the table
        pagination
        paginationPerPage={usersPerPage}
        paginationRowsPerPageOptions={[5, 8, 12, 18]}
        highlightOnHover
      />

      {/* Edit User Modal */}
      <div
        className={`modal ${editUser ? 'show' : ''} edt`}
        style={{ display: editUser ? 'block' : 'none' }}
        aria-hidden={!editUser}
      >
        <div className="modal-dialog">
          <div className="modal-content" id="new-pop">
            <div className="modal-header">
              <h5 className="modal-title">Edit User</h5>
              <button type="button" className="close" onClick={() => setEditUser(null)}>
                <span>&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="form-group">
                <label>Email</label>
                <input
                  type="email"
                  className="form-control"
                  placeholder="Email"
                  value={updatedUserData.email}
                  onChange={(e) =>
                    setUpdatedUserData({ ...updatedUserData, email: e.target.value })
                  }
                />
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-primary cus-btn-hover-affect" onClick={() => handleUpdateUser(editUser.id)}>
                Update
              </button>
              <button className="btn btn-secondary" onClick={() => setEditUser(null)}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
      {editUser && <div className="modal-backdrop fade show"></div>}
    </div>
  );
};

export default UserList;
